 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		38: 0,
 		47: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"vendors~BulkRoster~MergeApproval~MergeRequest~ProvisionSchools~Pygmalion","5":"News","6":"MergeApproval~MergeRequest","7":"Search","8":"vendors~BulkRoster~ProvisionSchools","10":"AssignmentContainer","11":"AssignmentsContainer","12":"BulkRoster","13":"Categories","14":"Collections","15":"LazyAssignedArticleReviewContainer","16":"LazyCanvasAssignmentReviewContainer","17":"LazySearchComponent","18":"LessonSparkContainer","19":"MergeApproval","20":"MergeRequest","21":"OpenMergeRequests","22":"ProvisionSchools","23":"Pygmalion","24":"ReadContainer","25":"Rules","26":"SignIn","27":"StandaloneAudioTrack","28":"StandaloneExternalEmbed","29":"StandalonePoll","30":"StandaloneVideo","31":"StandardContainer","32":"TeacherBinder","33":"TeacherOnboarding","34":"TextSets","35":"UnitsContainer","36":"UserDash","37":"YourContentContainer","39":"browse"}[chunkId]||chunkId) + "." + {"0":"01df66a5f77de24c8f7f","1":"b9b0e77c829cd5e47a34","2":"e51b1fb56b9a507f3e45","3":"af81548348caa015596d","4":"50ea701b9892e68d5605","5":"3048eb2bdc1431064735","6":"2c44ba3aa7617cb380f5","7":"5f05eacd994b1c31c483","8":"d389c2996bc442461ccd","9":"d3c650b0810db0d5b814","10":"917066e60e16ce8e02a0","11":"5c9ad1cb2af0f0b185bf","12":"9ef05b49b7af84a4414b","13":"41318db389a56136da3b","14":"daade1d2dd2b19e3fa75","15":"7c9b7028c50a7ef6a786","16":"0ab344da6751b4cf2588","17":"0a59bd6d961906dd12fc","18":"81d2aaed690ca70f3d1f","19":"0e82cdf164934b9e0763","20":"877dcf4b15baa4d7bbc8","21":"5fa9cfb90627dcbf0764","22":"6b075aff99c5fad885af","23":"9973453c4b21b7ea40ca","24":"64657a491b1a8aa925b5","25":"7f71ad60d86aaef20e61","26":"a5e6750748f028bf8f39","27":"5e148432fc8ad6edd617","28":"bf6b4acf37f9f1cceb61","29":"35187bbdddaa098eb36e","30":"f8353f7465ebb8db794a","31":"20d4d219a694fc3a4469","32":"7ae3fd3112290e7d391f","33":"6c1feb813c68b35ef71b","34":"8d9b9418c05b2affd680","35":"b0044f0be7ad6eb7293c","36":"31b4b7d8b09cba716f57","37":"424929d45d68ec33784d","39":"71e7ae3198d22ee6a9f6","41":"071038e10ea9b1810861","42":"c35ff60874da9a47e747","43":"8958305adef6ad97aecb","44":"4eebbba4d94a88db6fad","45":"bd8c543383c4b7f26072","46":"41a7c4d333e8fc41aa5b","47":"5ae77281bb0329468172","48":"c5019ba9a1ad2f253fe4","49":"dba0cd706e9f32fa63c9","50":"677aae72a3ba25083ca8","51":"b6ae21dcf74885eb9cbf","52":"b13d773d0963f16ca2f2","53":"b42e010772e22bfaf3b5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1877);
